(() => {
  if (window.__uspCardLinksBound) return;
  window.__uspCardLinksBound = true;

  const TAP_SLOP_PX = 10;
  const NESTED_CONTROL =
    'a:not(.usp-item__card-link), button, input, select, textarea, summary, [role="button"]';

  let pointerOrigin = null;

  document.addEventListener(
    'pointerdown',
    (event) => {
      const card = event.target.closest('.usp-item--linked');
      if (!card) {
        pointerOrigin = null;
        return;
      }
      pointerOrigin = {
        card,
        x: event.clientX,
        y: event.clientY
      };
    },
    { passive: true }
  );

  document.addEventListener(
    'click',
    (event) => {
      if (!pointerOrigin) return;

      const card = event.target.closest('.usp-item--linked');
      const origin = pointerOrigin;
      pointerOrigin = null;

      if (!card || card !== origin.card) return;
      if (Math.hypot(event.clientX - origin.x, event.clientY - origin.y) > TAP_SLOP_PX) {
        return;
      }
      if (event.target.closest(NESTED_CONTROL)) return;

      const link = card.querySelector('.usp-item__card-link');
      if (!link || !link.href) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (link.target === '_blank') {
        window.open(link.href, '_blank', 'noopener,noreferrer');
        return;
      }

      window.location.assign(link.href);
    },
    true
  );
})();
